/**
 * MessageTemplatePresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  Table,
  TabMenu,
  InputFormTable,
  Pagination,
} from 'components';
import { Button, Input } from 'antd';
import moment from 'moment';

const MessageTemplatePresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [type, setType] = useState('email');

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form = [
    {
      label: '템플릿 제목',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                style={{ ...styles.form.input.large, width: '100%' }}
                placeholder="템플릿 제목을 입력해주세요"
              />
            </>
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: `${
        type === 'email' ? '이메일' : type === 'sms' ? '문자' : '푸시알림'
      } 제목`,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                style={{ ...styles.form.input.large, width: '100%' }}
                placeholder={`${
                  type === 'email'
                    ? '이메일'
                    : type === 'sms'
                    ? '문자'
                    : '푸시알림'
                } 제목을 입력해주세요`}
              />
            </>
          ),
          fullscreen: true,
        },
      ],
    },
    {
      label: `${
        type === 'email' ? '이메일' : type === 'sms' ? '문자' : '푸시알림'
      } 내용`,
      form: [
        {
          input: (
            <>
              <Input.TextArea
                size="large"
                style={{
                  ...styles.form.input.large,
                  width: '100%',
                  height: 140,
                }}
                placeholder={`${
                  type === 'email'
                    ? '이메일'
                    : type === 'sms'
                    ? '문자'
                    : '푸시알림'
                } 내용을 입력해주세요`}
              />
            </>
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      전송번호: '000000',
      발송타입: '결제 메일',
      생성시간: new Date(),
      관리자: `관리자 ${i + 1}`,
      템플릿제목: `결제 메일 템플릿${i + 1}`,
      메일제목: `000님 결제 관련 되어 안내사항 전달드립니다.`,
      메일내용: `결제관련 안내말씀드립니다. 금일 부터 현재 사용 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고`,
      전송결과: i < 4 ? '전송 완료' : '전송 예약',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>템플릿 관리</Title>

          <Row gutter={[1, 1]}>
            <Col x={4}>
              <Content
                maxWidth={'100%'}
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: '150%',
                  }}
                >
                  기본설정
                </h4>
              </Content>
            </Col>

            <Col x={20}>
              <Content
                maxWidth={'100%'}
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <h2
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: '#404040',
                    lineHeight: '133%',
                  }}
                >
                  {type === 'email'
                    ? '이메일'
                    : type === 'sms'
                    ? '문자'
                    : '푸시알림'}{' '}
                  템플릿 등록
                </h2>
              </Content>
            </Col>

            <Col
              x={4}
              style={{
                background: '#FFFFFF',
              }}
            >
              <Content maxWidth={'100%'} style={{ height: '100%' }}>
                <TabMenu
                  items={[
                    { key: 'email', label: '이메일 템플릿 등록' },
                    { key: 'sms', label: '문자 템플릿 등록' },
                    { key: 'notification', label: '푸시알림 템플릿 등록' },
                  ]}
                  onChange={({ key }) => setType(key)}
                />
              </Content>
            </Col>

            <Col x={20}>
              <Content
                maxWidth={'100%'}
                padding={10}
                style={{ height: '100%' }}
              >
                <InputFormTable form={form} />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 20,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                  >
                    저장
                  </Button>
                  <Button size="large" style={{ ...styles.button }}>
                    초기화
                  </Button>
                </div>
              </Content>
            </Col>
            {/* 정산내역 끝 */}

            <Col x={24}>
              <Content
                maxWidth={'100%'}
                style={{ marginTop: 40 }}
                borderRadius={4}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                  }}
                >
                  <h4 style={{ fontSize: 14, fontWeight: 500 }}>
                    총 <span>0</span>건
                  </h4>
                </div>
                <Table
                  data={newData}
                  columns={[
                    {
                      title: '전송 번호',
                      key: '전송번호',
                    },
                    {
                      title: '발송 타입',
                      key: '발송타입',
                      render: (item) => (
                        <span
                          style={{
                            padding: '7px 3px',
                            border: '0.5px solid #B2B2B2',
                            borderRadius: 4,
                          }}
                        >
                          {item}
                        </span>
                      ),
                    },
                    {
                      title: '생성 시간',
                      key: '생성시간',
                      render: (item) =>
                        moment(item).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                      title: '관리자',
                      key: '관리자',
                    },
                    {
                      title: '템플릿 제목',
                      key: '템플릿제목',
                    },
                    {
                      title: '메일 제목',
                      key: '메일제목',
                      render: (item) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '메일 내용',
                      key: '메일내용',
                      width: 300,
                      style: {
                        maxWidth: 500,
                        padding: 8,
                      },
                    },
                    {
                      title: '비고',
                      key: '비고',
                      render: () => (
                        <>
                          <Button
                            size="small"
                            style={{
                              borderColor: 'var(--primary-color)',
                              color: 'var(--primary-color)',
                              marginRight: 4,
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            size="small"
                            style={{ borderColor: '#EE4700', color: '#EE4700' }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
                <Pagination total={40} style={{ marginTop: 40 }} />
              </Content>
            </Col>
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default MessageTemplatePresenter;
